window.initGameDemo = (options = {
    generateGameUrl: undefined,
    generateHighRateGameUrl: undefined,
    onIframeOpenCallback: undefined,
    onIframeCloseCallback: undefined,
    isSpecialCatalog: false
}) => {
    const md = new MobileDetect(window.navigator.userAgent);
    const widgetBlock = $('.game_iframe');
    const mobileBlock = $('.game_iframe__mobile');
    const mobileShadowBlock = $('.game_iframe__mobile_light');
    const gameIFrame = $('#game-demo-iframe');
    const gameIFrameMask = $('.iframe-mask');
    let timesFrameLoaded = 0;
    let isOpened = false;

    const closeButton = $('.game_iframe__close');
    const rotateButton = $('.game_iframe__button');

    function updateAdBlockWarning() {
        const adblockOff = $('.adblock_off');
        if (gameIFrame.attr('style') !== '' || gameIFrame.is(':hidden')) {
            adblockOff.show();
        } else {
            adblockOff.hide();
        }
    }
    updateAdBlockWarning();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type == 'attributes' && mutation.attributeName == 'style') {
                updateAdBlockWarning();
            }
        });
    });
    observer.observe(gameIFrame.get(0), {
        attributes: true,
        attributeFilter: ['style']
    });

    const getGameId = () => {
        return window.currentGameId || 0;
    };
    const setGameId = (id) => {
        window.currentGameId = id;
    };

    const getGameCode = () => {
        return window.currentGameCode;
    };
    const setGameCode = (code) => {
        window.currentGameCode = code;
    };
    const clearGameCodeParam = () => {
        const url = new Domurl();
        if (url.query.game) {
            delete url.query.game;
        }
        window.history.replaceState('', '', url.toString());
    };

    const getGameMode = () => {
        return window.gamemode;
    };
    const setGameMode = (gamemode) => {
        window.gamemode = gamemode;
    };
    const isHighrateGameMode = () => {
        return getGameMode() === 'highrate';
    }

    function isMobileDevice() {
        return md.mobile();
    }
    function isSmallDevice() {
        return $(window).width() < 1024;
    }

    function getGameSessionType() {
        if (!options.isSpecialCatalog) {
            return (isMobileDevice() || isSmallDevice()) ? 'mobile' : 'desktop'
        }

        return undefined;
    }

    function onIframeLoad() {
        timesFrameLoaded++;

        if (timesFrameLoaded === 2) {
            gameIFrameMask.hide();
        } else if (timesFrameLoaded === 3) {
            closeWithHistory();
        }
    }

    const resetIframe = () => {
        gameIFrame.remove();
        gameIFrame.attr('src', 'about:blank');
        mobileBlock.append(gameIFrame);
        gameIFrame.on('load', onIframeLoad);
    }

    function onRotate() {
        gameIFrameMask.show();
        gameIFrameMask.css('z-index', 1);

        mobileBlock.toggleClass('rotate');
        mobileShadowBlock.toggleClass('rotate');

        setTimeout(() => {
            gameIFrameMask.css('z-index', -1);
            gameIFrameMask.hide();
        }, 200);
    }

    function onClose() {
        if (isOpened) {
            isOpened = false;
            resetIframe();
            widgetBlock.hide();
            if (options.onIframeCloseCallback) options.onIframeCloseCallback();
            clearGameCodeParam();
        }
    }

    function closeWithHistory() {
        if (isOpened) {
            history.back();
        }
    }

    rotateButton.click(onRotate);
    closeButton.click(closeWithHistory);
    gameIFrame.on('load', onIframeLoad);

    window.openGameDemoWidget = () => {
        const gameCode = getGameCode();
        if (gameCode) {
            const url = new Domurl();
            url.query.game = gameCode;
            window.history.replaceState('', '', url.toString());
        }

        window.location.hash = '#demoStart';
    };

    function getGameSessionUrl(onComplete) {
        const gameId = getGameId();
        const url = isHighrateGameMode() ? options.generateHighRateGameUrl : options.generateGameUrl;
        const sessionType = getGameSessionType();
        let data = {
            id: gameId
        };

        if (sessionType) {
            data.sessionType = sessionType;
        }

        $.ajax({
            method: 'POST',
            url: url,
            data: data,
            dataType: 'text',
            complete: onComplete,
            timeout: 10000
        });
    }

    function openGameDemoWidget() {
        if (options.onIframeOpenCallback) options.onIframeOpenCallback();
        timesFrameLoaded = 0;
        isOpened = true;
        gameIFrameMask.show();
        widgetBlock.show();

        getGameSessionUrl((xhr) => {
            if (xhr.status === 200 && xhr.responseText) {
                gameIFrame.get(0).contentWindow.location.replace(xhr.responseText);
            } else {
                closeWithHistory();
                $('.error__window_wrapper').show();
            }
        });
    }

    function openNewGameInNewWindow($button) {
        $button.addClass('blocked');
        const windowReference = window.open();

        getGameSessionUrl((xhr) => {
            if (xhr.status === 200 && xhr.responseText) {
                windowReference.location = xhr.responseText;
            } else {
                $('.error__window_wrapper').show();
            }

            $button.removeClass('blocked');
        });
    }

    function onHashChange() {
        if (window.location.hash === '#demoStart' && getGameId()) {
            openGameDemoWidget();
        } else {
            onClose();
        }
    }
    $(window).on('hashchange', onHashChange);

    clearGameCodeParam();
    if (window.location.hash === '#demoStart') {
        history.replaceState('', document.title, window.location.href.split('#')[0]);
    } else if (window.location.hash === '#demoPreopen') {
        window.location.hash = '#demoStart';
    }

    $(document).keyup((e) => {
        if (e.keyCode === 27 && isOpened) {
            closeWithHistory();
        }
    });

    window.startGame = (gameID, gameCode, gameMode, gameDemoIframeUrl, $button) => {
        setGameId(gameID);
        setGameCode(gameCode);
        setGameMode(gameMode);

        if (options.isSpecialCatalog) {
            if (isMobileDevice() && isSmallDevice()) {
                openNewGameInNewWindow($button);
            } else {
                window.location.href = gameDemoIframeUrl;
            }
        } else {
            if (isMobileDevice() || isSmallDevice()) {
                openNewGameInNewWindow($button);
            } else {
                window.openGameDemoWidget();
            }
        }

    }

    window.initStartGameDemoButton = (buttonClass) => {
        const button = $(`.${buttonClass}`);

        button.removeClass('blocked');
        button.click((e) => {
            e.preventDefault();
            const $button = $(e.currentTarget);
            const gameID = $button.data('id') || 0;
            const gameCode = $button.data('code') || '';
            const gameMode = $button.data('game-mode');
            const gameDemoIframeUrl = $button.data('fullscreen-demo-iframe');

            window.startGame(gameID, gameCode, gameMode, gameDemoIframeUrl, $button);
        });
    };
}
